import React, { useState, useEffect } from 'react';
import {
    Drawer,
    Form,
    Input,
    Select,
    Switch,
    InputNumber,
    Button,
    Space,
    message,
    Divider
} from 'antd';
import { campaignService, pbxService } from '../services/api';

const { Option } = Select;

const CampaignDrawer = ({ visible, onClose, campaign = null, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [forms, setForms] = useState([]);
    const isEdit = !!campaign;

    useEffect(() => {
        if (visible) {
            fetchForms();
            if (campaign) {
                form.setFieldsValue({
                    ...campaign,
                    record: !!campaign.record,
                    is_active: !!campaign.is_active
                });
            } else {
                form.resetFields();
                form.setFieldsValue({
                    type: 'outbound',
                    record: 1,
                    is_active: 1,
                    weight: 0
                });
            }
        }
    }, [visible, campaign, form]);

    const fetchForms = async () => {
        try {
            const res = await pbxService.listForms();
            if (res.status === 'success') {
                setForms(res.data);
            }
        } catch (error) {
            console.error('Error fetching forms:', error);
        }
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            // Fetch navigation ID from local storage or context if available
            const navigationId = localStorage.getItem('currentNavigationId') || 0;

            const payload = {
                ...values,
                navigation_id: navigationId,
                record: values.record ? 1 : 0,
                is_active: values.is_active ? 1 : 0
            };

            let res;
            if (isEdit) {
                res = await campaignService.update({ ...payload, id: campaign.id });
            } else {
                res = await campaignService.create(payload);
            }

            if (res.status === 'success') {
                message.success(`Campaña ${isEdit ? 'actualizada' : 'creada'} correctamente`);
                onSuccess();
                onClose();
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Error al guardar la campaña';
            message.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Drawer
            title={isEdit ? 'Editar Campaña' : 'Nueva Campaña'}
            width={480}
            onClose={onClose}
            open={visible}
            extra={
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button type="primary" onClick={handleSubmit} loading={loading}>
                        Guardar
                    </Button>
                </Space>
            }
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="Nombre de la Campaña"
                    name="name"
                    rules={[{ required: true, message: 'Por favor ingrese el nombre' }]}
                >
                    <Input placeholder="Ej. Campaña de Donaciones 2025" />
                </Form.Item>

                <Form.Item
                    label="Tipo"
                    name="type"
                    rules={[{ required: true, message: 'Seleccione un tipo' }]}
                >
                    <Select placeholder="Seleccione el tipo">
                        <Option value="inbound">Entrante (Inbound)</Option>
                        <Option value="outbound">Saliente (Outbound)</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => prevValues.type !== currentValues.type}
                >
                    {({ getFieldValue }) =>
                        getFieldValue('type') === 'outbound' ? (
                            <Form.Item
                                label="Data de origen"
                                name="origen_data"
                                rules={[{ required: true, message: 'Seleccione el origen de datos' }]}
                            >
                                <Select placeholder="Seleccione el origen">
                                    <Option value="base contacts">Base de contactos</Option>
                                    <Option value="agent">Cargado por el Agente</Option>
                                </Select>
                            </Form.Item>
                        ) : null
                    }
                </Form.Item>

                <Form.Item
                    label="Formulario Dinámico"
                    name="form_id"
                >
                    <Select placeholder="Seleccione un formulario (opcional)" allowClear>
                        {forms.map(f => (
                            <Option key={f.id} value={f.id}>{f.name}</Option>
                        ))}
                    </Select>
                </Form.Item>

                <Divider />

                <Space size="large">
                    <Form.Item label="Grabar Llamada" name="record" valuePropName="checked">
                        <Switch />
                    </Form.Item>

                    <Form.Item label="Operativa" name="is_active" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </Space>

                <Form.Item
                    label="Prioridad / Peso"
                    name="weight"
                    tooltip="Mayor valor indica mayor prioridad en las colas"
                >
                    <InputNumber min={0} max={100} style={{ width: '100%' }} />
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default CampaignDrawer;
